module.exports = __webpack_public_path__ + "img/appAsset-setup--SecondStep.90646a76.svg";